<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->
<div class="paragraph-container">
  <ptl-resource-preview [previewContent]="content"></ptl-resource-preview>
</div>
